<template>
  <div id="app">
    <app-mheader v-if="mheader_show"></app-mheader>
    <app-header v-if="header_show"></app-header>
    <app-menu v-if="menu_show"></app-menu>
    <router-view v-on:header="header" v-on:footer="footer"></router-view>
    <app-footer v-if="footer_show"></app-footer>
    <app-mfooter v-if="mfooter_show"></app-mfooter>
  </div>
</template>

<script>
import Header from "./components/common/header";
import Footer from "./components/common/footer";
import mHeader from "./components/mobile/common/header";
import mFooter from "./components/mobile/common/footer";
import menu from "./components/mobile/common/menu";
export default {
  name: "App",
  data() {
    return {
      header_show: false,
      footer_show: false,
      mheader_show: false,
      mfooter_show: false,
      menu_show:false
    };
  },
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "app-mheader": mHeader,
    "app-mfooter": mFooter,
    "app-menu": menu,
  },
  mounted() {
    if (this._isMobile()) {
      this.$router.replace('/mHome');
      this.mheader_show=true
      this.mfooter_show=true
      // document.querySelector('body').removeAttribute('style')
      document.getElementById('app').setAttribute('class', 'mobile')
    } else {
      this.$router.replace('/Home');
      this.header_show=true
      this.footer_show=true
      document.querySelector('body').setAttribute('style', 'min-width: 1360px;')
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //是否显示头部
    header: function(bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer: function(bool) {
      this.footer_show = bool;
    },
    mfooter: function(bool) {
      this.mfooter_show = bool;
    }
  }
};
</script>

<style lang="less" type="text/less">
  a{
    text-decoration:none;
    out-line: none;
    color: #666;
  }
body {
   #app.mobile{
    transition: transform .5s;
    position:absolute;
  }
  .countryImg{
    width: 24px;
    margin-right: 10px;
  }
}
#app {
  font-family: "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  font-size: 18px;
  width:100%;
}
body.open-nav{
  overflow: hidden;
  padding: 0;
  position: fixed;
  top: 0;
  width: 100%;
  #app{
    transform: translate(-300px);
    transition: transform .5s;
    position:absolute;
  }
  .mask{
    background: rgba(0,0,0,0.2);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 333;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue